import React from 'react';
import {iconMapByQType} from "../../../../../utils/SurveyUtils";
import QuestionViewMode from '../../../survey/builder/view_mode/QuestionViewMode';


function TemplateQuestionBox(props) {
    return (
        <div className="
        questionaire__builder__question
        questionaire__builder__question--shadow
        ">
            <div className="
            questionaire__builder__question__title
            questionaire__builder__question__title--dark
            ">
                <span className="questionaire__builder__question__title__number">{props.questionData.id}</span>
                {props.questionData.type &&
                (
                    <React.Fragment>
                        <span className={"questionaire__builder__question__title__icon questionaire__builder__question__title__icon--" + (iconMapByQType[props.questionData.type] ? iconMapByQType[props.questionData.type] : "single")}></span>
                        <span className="questionaire__builder__question__title__text ">
                            {props.questionData.question}
                        </span>
                    </React.Fragment>
                )
                }
            </div>
            <QuestionViewMode questionData={props.questionData}/>
        </div>
                    
    )
}

export default TemplateQuestionBox
